/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Modal,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { BadgeStatusPrLists } from '../../../components/atoms/StatusLabel'
import { ChevronDown, ChevronUp, Download } from 'lucide-react'
import Loading from '../../../components/atoms/Loading'
import api from '../../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import { convertDateWithTime } from '../../../helpers/constants'
import ModalStockAdjustment from '../../../components/modal/stockAdjustment/ModalStockAdjustment'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const StyledDetailField = ({ label, value, col = 3, children, address }) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      <div
        className="px-0"
        style={{
          fontSize: '0.9rem',
          fontWeight: '500',
          color: '#212529',
          minHeight: '24px'
        }}
      >
        {address ? (
          <div dangerouslySetInnerHTML={{ __html: value }} />
        ) : children ? (
          children
        ) : (
          value
        )}
      </div>
    </Form.Group>
  )
}

function DetailJobStatus() {
  const { id } = useParams()
  const navigate = useNavigate()
  const { state } = useLocation()
  const [progressCollapse, setProgressCollapse] = useState(true)
  const [destinationAreas, setDestinationAreas] = useState([])
  const [data, setData] = useState(null)
  const [resultCount, setResultCount] = useState({
    total: 0,
    utama: 0,
    vas: 0,
    karantina: 0
  })
  const [formReorder, setFormReorder] = useState({
    utama: '',
    vas: ''
  })
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState({
    page: false,
    ids: {},
    download: false,
    submit: false
  })
  const handleDownloadLabel = async (valueId) => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        ids: {
          ...prevLoading.ids,
          [valueId]: true
        }
      }))
      const res = await api.get(`job-status/${data?.id}/${valueId}/label`, {
        responseType: 'arraybuffer'
      })
      const { status, data: dataResponse } = res
      if (status === 200) {
        const blob = new Blob([dataResponse], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `download-label-${valueId}.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        ids: {
          ...prevLoading.ids,
          [valueId]: false
        }
      }))
    }
  }
  const handleDownloadPhotoNotFit = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        download: true
      }))
      const res = await api.get(`job-status/${data?.id}/document`, {
        responseType: 'arraybuffer'
      })
      const { status, data: dataResponse } = res
      if (status === 200) {
        const blob = new Blob([dataResponse], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `download-document-${data?.id}.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        download: false
      }))
    }
  }
  const renderLabel = (data) => (
    <div key={data.id}>
      <Button
        type="button"
        variant={loading.ids[data.id] ? 'secondary' : 'warning'}
        className={`${!loading.ids[data.id] ? 'text-light' : 'opacity-25'}`}
        onClick={() => handleDownloadLabel(data.id)}
      >
        <Download size={14} />
      </Button>
    </div>
  )
  const renderLocation = (data) => {
    if (!data.is_packing) {
      return (
        <div
          key={data.id}
          className="w-100 d-flex justify-content-end"
          role="button"
          tabIndex={0}
        >
          <div
            className="text-truncate text-primary cursor-pointer"
            style={{ width: '150px' }}
          >
            {data.location}
          </div>
        </div>
      )
    }
    return '-'
  }
  const readCodeLabel = (code) => {
    if (code === 'UT') {
      return 'utama'
    }
    if (code === 'VAS') {
      return 'vas'
    }
    if (code === 'KR') {
      return 'karantina'
    }
    return '-'
  }
  const handleSelectDestArea = (value, resultValueId) => {
    const findDataResult = data?.result?.find(
      (item) => item.id === resultValueId
    )?.dest_location
    const areaBefore = destinationAreas?.find(
      (area) => area.id === findDataResult
    )
    const areaAfter = destinationAreas?.find((area) => area.id === value)
    if (areaBefore) {
      setResultCount((prevResultCount) => ({
        ...prevResultCount,
        [readCodeLabel(areaBefore?.code)]:
          Number(prevResultCount[readCodeLabel(areaBefore?.code)]) - 1,
        [readCodeLabel(areaAfter?.code)]:
          Number(prevResultCount[readCodeLabel(areaAfter?.code)]) + 1
      }))
    } else {
      setResultCount((prevResultCount) => ({
        ...prevResultCount,
        [readCodeLabel(areaAfter?.code)]:
          Number(prevResultCount[readCodeLabel(areaAfter?.code)]) + 1
      }))
    }
    setData((prevData) => ({
      ...prevData,
      result: prevData.result.map((item) => {
        if (item.id === resultValueId) {
          return {
            ...item,
            dest_location: value
          }
        }
        return item
      })
    }))
  }
  const renderDestLocation = (value) => {
    if (value?.needSelected && data?.status === 'waiting_om') {
      return (
        <div key={value?.id}>
          <Form.Select
            aria-label="dest_location"
            onChange={(e) => handleSelectDestArea(e.target.value, value?.id)}
            value={value?.dest_location || ''}
          >
            <option>Select Area</option>
            {destinationAreas?.map((area) => (
              <option key={area.id} value={area.id}>
                {area.name}
              </option>
            ))}
          </Form.Select>
        </div>
      )
    }
    return value?.dest_location
  }
  const columnTarget = [
    { key: 'sequence', label: 'No' },
    { key: 'item_name', label: 'Item' },
    { key: 'item_code', label: 'Item Code' },
    { key: 'batch', label: 'Batch', className: 'text-end' },
    {
      key: 'expired_at',
      label: 'Expired',
      className: 'text-end',
      component: (value) =>
        value?.exp_date
          ? convertDateWithTime(value?.exp_date, 'DD-MM-YYYY')
          : '-'
    },
    {
      key: 'qty_pack',
      label: 'Qty @pack',
      className: 'text-end',
      component: (value) =>
        value?.qty_pack ? `${value?.qty_pack} ${value?.uom_pack}` : '-'
    },
    {
      key: 'total_qty',
      label: 'Total Qty',
      className: 'text-end'
    },
    {
      key: 'uom',
      label: 'UOM',
      className: 'text-end'
    },
    {
      key: 'total_pack',
      label: 'Total Pack',
      className: 'text-end',
      component: (value) =>
        value?.total_pack ? `${value?.total_pack} ${value?.uom_pack}` : '-'
    }
  ]
  const columnSource = [
    { key: 'sequence', label: 'No' },
    { key: 'item', label: 'Item' },
    { key: 'item_code', label: 'Item Code' },
    {
      key: 'batch',
      label: 'Batch',
      className: 'text-end',
      component: (value) => value?.batch || '-'
    },
    {
      key: 'expired_at',
      label: 'Expired',
      className: 'text-end',
      component: (value) =>
        value?.exp_date
          ? convertDateWithTime(value?.exp_date, 'DD-MM-YYYY')
          : '-'
    },
    {
      key: 'total_qty',
      label: 'Total Qty',
      className: 'text-end',
      component: (value) =>
        value?.total_qty ? `${value.total_qty} ${value.uom}` : '-'
    },
    {
      key: 'total_pack',
      label: 'Total Pack',
      className: 'text-end',
      component: (value) =>
        value?.total_pack ? `${value.total_pack} ${value.uom_pack}` : '-'
    },
    {
      key: 'location',
      label: 'Location',
      className: 'text-end',
      component: (data) => renderLocation(data)
    }
  ]
  const columnResult = [
    { key: 'item_name', label: 'Item' },
    {
      key: 'pack',
      label: 'Pack',
      className: 'text-end',
      component: (value) =>
        value?.total_pack ? `${value?.total_pack} ${value?.uom_pack}` : '-'
    },
    { key: 'location', label: 'Location', className: 'text-end' },
    {
      key: 'scale_weight',
      label: 'Berat Timbangan',
      className: 'text-end',
      component: (value) =>
        value?.scale_weight ? `${value?.scale_weight} ${value?.uom}` : '-'
    },
    {
      key: 'dest_location',
      label: 'Destination Area',
      className: 'text-end',
      component: (data) => renderDestLocation(data)
    },
    {
      key: 'label',
      label: 'Label',
      className: 'text-end',
      component: (data) => renderLabel(data)
    }
  ]
  const fetchData = async () => {
    try {
      setLoading({ ...loading, page: true })
      const response = await api.get(`job-status/${id}`)
      const { data: dataResponse } = response
      if (dataResponse.success) {
        setData({
          ...dataResponse.data,
          result: dataResponse?.data?.result.map((item) => {
            return {
              ...item,
              needSelected: !item.dest_location ? true : false
            }
          })
        })
        // counting based on area
        setResultCount((prevResultCount) => ({
          ...prevResultCount,
          total:
            dataResponse?.data?.result?.filter(
              (item) => item.dest_location !== 'Area Gudang Karantina'
            ).length || 0,
          karantina:
            dataResponse?.data?.result?.filter(
              (item) => item.dest_location === 'Area Gudang Karantina'
            )?.length || 0,
          utama:
            dataResponse?.data?.result?.filter(
              (item) => item.dest_location === 'Area Gudang Utama'
            )?.length || 0,
          vas:
            dataResponse?.data?.result?.filter(
              (item) => item.dest_location === 'Area VAS'
            )?.length || 0
        }))
        if (
          dataResponse?.data?.result?.some(
            (result) => !result?.dest_location
          ) &&
          !destinationAreas.length
        ) {
          fetchAreas(dataResponse.data.warehouse_id || '')
        }
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      navigate('/workorder/job-status', {
        replace: true,
        state: state
      })
    } finally {
      setLoading({ ...loading, page: false })
    }
  }
  const fetchAreas = async (warehouseId = '') => {
    try {
      const params = {
        id: warehouseId,
        for_repack: 1
      }
      const response = await api.get('master/area/all', { params })
      const { data: dataResponse } = response
      if (dataResponse.success) {
        setDestinationAreas(dataResponse.data)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const handleSubmitDestArea = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        submit: true
      }))
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      const payload = {
        result_area: data?.result
          ?.filter((item) => uuidRegex.test(item.dest_location))
          .map(({ needSelected, ...item }) => item)
      }
      const response = await api.post(`job-status/${data?.id}/area`, payload)
      const { data: dataResponse } = response
      if (dataResponse.success) {
        fetchData()
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        submit: false
      }))
    }
  }
  const reOrderButtonDisabled = useMemo(() => {
    if (formReorder?.utama === '' || formReorder?.vas === '') return true
    return Number(formReorder?.utama) + Number(formReorder?.vas) !==
      resultCount.total
      ? true
      : false
  }, [formReorder?.utama, formReorder?.vas])
  const handleReorderSubmit = () => {
    const dataReorderWithoutKarantina =
      data?.result
        ?.filter(
          (item) =>
            item.dest_location !== 'Area Gudang Karantina' &&
            item.dest_location !== 'Area Gudang Karantina Dingin'
        )
        ?.map((item) => item.id) || []

    if (!dataReorderWithoutKarantina.length) {
      return toast.error('Please select at least one item', {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }

    const idUtama = destinationAreas?.find((area) => area.code === 'UT')?.id
    const idVas = destinationAreas?.find((area) => area.code === 'VAS')?.id

    const dataUtama = dataReorderWithoutKarantina.slice(0, formReorder.utama)
    const dataVas = dataReorderWithoutKarantina.slice(
      formReorder.utama,
      Number(formReorder.utama) + Number(formReorder.vas)
    )
    setData((prevData) => ({
      ...prevData,
      result: prevData.result.map((item) => {
        if (dataUtama.includes(item.id)) {
          return {
            ...item,
            dest_location: idUtama
          }
        }
        if (dataVas.includes(item.id)) {
          return {
            ...item,
            dest_location: idVas
          }
        }
        return item
      })
    }))

    setResultCount((prevResultCount) => ({
      ...prevResultCount,
      utama: formReorder.utama,
      vas: formReorder.vas
    }))

    handleModal()
  }

  const handleModal = () => {
    const isOpenValue = !isOpen
    setIsOpen(isOpenValue)
    if (!isOpenValue) {
      setFormReorder({
        utama: '',
        vas: ''
      })
    } else {
      setFormReorder({
        utama: resultCount.utama === 0 ? '' : Number(resultCount.utama),
        vas: resultCount.vas === 0 ? '' : Number(resultCount.vas)
      })
    }
  }
  useEffect(() => {
    fetchData()
  }, [id])
  if (loading.page) {
    return <Loading />
  }
  return (
    <>
      <Toaster />
      <Container>
        <Row className="mb-3">
          <Col md={12}>
            <div className="d-flex flex-column justify-content-start">
              <h6 className="header-title-style" style={{ fontSize: '18px' }}>
                {data?.code || ''}{' '}
                <sup>
                  <BadgeStatusPrLists text={data?.status?.replace('_', ' ')} />
                </sup>
              </h6>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb fs-6 mb-0">
                  <li className="breadcrumb-item">
                    <Link
                      to="/workorder/job-status"
                      state={state}
                      className="text-decoration-none"
                    >
                      <span className="text-black fw-bold text-uppercase">
                        Job Status
                      </span>
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item sj-item active"
                    aria-current="page"
                  >
                    {data?.code || ''}
                  </li>
                </ol>
              </nav>
            </div>
          </Col>
        </Row>

        <Card style={cardStyle}>
          <h5 className="fw-bold text-uppercase mb-3" style={{ color: '#333' }}>
            Target
          </h5>
          <Table responsive hover style={{ fontSize: '13px' }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columnTarget.map((column) => (
                  <th
                    className={`align-middle p-2 ${column.className ?? ''}`}
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.target?.length > 0 &&
                data?.target?.map((item, index) => (
                  <tr key={`${item.id}-${index}`}>
                    {columnTarget.map((column) => (
                      <td
                        key={column.key}
                        className={`p-2 align-middle ${column.className ?? ''}`}
                      >
                        {column.key === 'sequence' && index + 1}
                        {column.component && column.component(item)}
                        {!column.component && item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </Table>
        </Card>

        <Card style={cardStyle}>
          <h5 className="fw-bold text-uppercase mb-3" style={{ color: '#333' }}>
            Source
          </h5>
          <Table responsive hover style={{ fontSize: '13px' }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columnSource.map((column) => (
                  <th
                    className={`align-middle p-2 ${column.className ?? ''}`}
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.sources?.length > 0 &&
                data?.sources?.map((item, index) => (
                  <tr key={`${item.id}-${index}`}>
                    {columnSource.map((column) => (
                      <td
                        key={column.key}
                        className={`p-2 align-middle ${column.className ?? ''}`}
                      >
                        {column.key === 'sequence' && index + 1}
                        {column.component && column.component(item)}
                        {!column.component && item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </Table>
        </Card>

        <Card style={cardStyle}>
          <div className="d-flex gap-1 justify-content-between">
            <h5
              className="fw-bold text-uppercase mb-3"
              style={{ color: '#333' }}
            >
              PROGRESS DETAIL
            </h5>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <Button
                variant="transparent"
                className="p-0"
                style={{ marginTop: '-0.2rem' }}
              >
                {progressCollapse ? (
                  <ChevronUp
                    size={16}
                    className="ms-1 text-muted"
                    onClick={() => setProgressCollapse(!progressCollapse)}
                    style={{ cursor: 'pointer' }}
                  />
                ) : (
                  <ChevronDown
                    size={16}
                    className="ms-1 text-muted"
                    onClick={() => setProgressCollapse(!progressCollapse)}
                    style={{ cursor: 'pointer' }}
                  />
                )}
              </Button>
            </div>
          </div>
          <Collapse in={progressCollapse}>
            <ul className="list-unstyled mb-0">
              {data?.progress?.length > 0 &&
                data?.progress?.map((progress) => (
                  <li key={progress?.datetime} className="mb-2">
                    <div className="d-flex flex-row gap-3 progress-detail align-items-center">
                      <div className="circle-progress-detail"></div>
                      <p
                        className="mb-0 text-muted"
                        style={{ fontSize: '0.9rem', minWidth: '100px' }}
                      >
                        {progress?.datetime}
                      </p>
                      <div
                        className="d-flex flex-column justify-content-center"
                        style={{ height: '20px' }}
                      >
                        <div className="d-flex flex-row gap-3 align-items-center">
                          <div className="circle-small-progress-detail"></div>
                          <span
                            className="fw-bold text-dark"
                            style={{ fontSize: '13px' }}
                          >
                            {progress?.description}
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </Collapse>
        </Card>

        <Card style={cardStyle}>
          <Row>
            <StyledDetailField
              label="pnp checker"
              value={data?.pnp || '-'}
              col={6}
            />
            <StyledDetailField
              label="rnr checker"
              value={data?.rnr || '-'}
              col={6}
            />
          </Row>
          <hr className="my-3" />

          <h5 className="fw-bold text-uppercase mb-3" style={{ color: '#333' }}>
            Result
          </h5>
          <div className="d-flex gap-4 my-2">
            <div className="w-100">
              <Table
                responsive
                style={{
                  borderRadius: '0px',
                  border: '1px solid #F1F2F7',
                  fontSize: '13px'
                }}
              >
                <thead>
                  <tr>
                    <td style={{ width: '120px' }}>Area Utama</td>
                    <td
                      style={{
                        background: '#F1F2F7',
                        textAlign: 'right',
                        width: '50px'
                      }}
                    >
                      {resultCount?.utama || 0}
                    </td>
                    <td>Area Vas</td>
                    <td
                      style={{
                        background: '#F1F2F7',
                        textAlign: 'right',
                        width: '50px'
                      }}
                    >
                      {resultCount?.vas || 0}
                    </td>
                    <td>Area Karantina</td>
                    <td
                      style={{
                        background: '#AFAFAF',
                        textAlign: 'right',
                        width: '50px',
                        borderRadius: '0'
                      }}
                    >
                      {resultCount?.karantina || 0}
                    </td>
                  </tr>
                </thead>
              </Table>
            </div>
            {data?.status !== 'done' && (
              <Button
                id="change-reorder"
                variant="transparent"
                type="button"
                style={{
                  border: '1px solid var(--primary-blue)',
                  height: '37px'
                }}
                onClick={handleModal}
              >
                Change
              </Button>
            )}
          </div>
          <Table responsive hover style={{ fontSize: '13px' }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columnResult.map((column) => (
                  <th
                    className={`align-middle p-2 ${column.className ?? ''}`}
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.result?.length > 0 &&
                data?.result?.map((item, index) => (
                  <tr key={`${item.id}-${index}`}>
                    {columnResult.map((column) => (
                      <td
                        key={column.key}
                        className={`p-2 align-middle ${column.className ?? ''}`}
                      >
                        {column.key === 'sequence' && index + 1}
                        {column.component && column.component(item)}
                        {!column.component && item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </Table>

          <Row className="mt-3">
            <Col md={12}>
              <div className="d-flex justify-between">
                {['waiting_om', 'done'].includes(data?.status) && (
                  <div className="w-50">
                    <Button
                      variant="transparent"
                      className={`${loading.download ? 'opacity-25' : ''}`}
                      onClick={handleDownloadPhotoNotFit}
                      disabled={loading.download}
                    >
                      <div className="d-flex gap-3">
                        <div className="d-flex align-items-center h-100 mt-1">
                          <Download
                            size={15}
                            style={{ color: 'orange' }}
                            className="mb-0"
                          />
                        </div>
                        <span
                          className="text-muted fw-bold"
                          style={{ fontSize: '14px' }}
                        >
                          {loading.download
                            ? 'Downloading...'
                            : 'Foto Barang Tidak Sesuai'}
                        </span>
                      </div>
                    </Button>
                  </div>
                )}
                {(data?.status === 'waiting_om' ||
                  data?.result?.some((result) => !result?.dest_location)) && (
                  <div className="d-flex justify-content-end gap-3 w-50">
                    <div className="d-flex align-items-center h-100">
                      <p className="text-danger mb-0">
                        Please select destination area according to your needs
                      </p>
                    </div>
                    <Button
                      variant="transparent"
                      className={`${
                        loading.submit ||
                        data?.result?.some((result) => !result?.dest_location)
                          ? 'btn-secondary opacity-25'
                          : 'btn-primary-orange'
                      }`}
                      disabled={
                        loading.submit ||
                        data?.result?.some((result) => !result?.dest_location)
                      }
                      onClick={handleSubmitDestArea}
                    >
                      Submit
                    </Button>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Card>

        <Card style={cardStyle}>
          <Row>
            <StyledDetailField
              label="created by"
              value={!data?.created_by ? '-' : data?.created_by}
              col={3}
            />
            <StyledDetailField
              label="created at"
              value={
                !data?.created_at ? '-' : convertDateWithTime(data?.created_at)
              }
              col={3}
            />
            <StyledDetailField
              label="last updated by"
              value={!data?.updated_by ? '-' : data?.updated_by}
              col={3}
            />
            <StyledDetailField
              label="last updated at"
              value={
                !data?.updated_at ? '-' : convertDateWithTime(data?.updated_at)
              }
              col={3}
            />
          </Row>
        </Card>
      </Container>
      <ModalStockAdjustment
        show={isOpen}
        onHide={handleModal}
        title="Select Destination"
        size="md"
        backdrop="static"
      >
        <Modal.Body
          className="my-2"
          style={{ height: '210px', overflowY: 'auto' }}
        >
          <div className="mb-5 mt-3">
            <div className="d-flex justify-content-between">
              <h6 className="fw-bold">Set qty for each area</h6>
              <h6 className="fw-bold text-success">
                Total Items: {resultCount.total}
              </h6>
            </div>
            <Row className="mt-2">
              <Col md={6}>
                <Form.Label
                  className="text-muted text-uppercase fw-bold"
                  htmlFor="qty-utama"
                >
                  Area Utama
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Area Utama"
                  value={formReorder.utama || ''}
                  onChange={(e) =>
                    setFormReorder({ ...formReorder, utama: e.target.value })
                  }
                />
              </Col>
              <Col md={6}>
                <Form.Label
                  className="text-muted text-uppercase fw-bold"
                  htmlFor="qty-vas"
                >
                  Area VAS
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Area VAS"
                  value={formReorder.vas || ''}
                  onChange={(e) =>
                    setFormReorder({ ...formReorder, vas: e.target.value })
                  }
                />
              </Col>
            </Row>
          </div>
          <Modal.Footer className="mt-3">
            <div>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="d-flex gap-2">
                  <Button
                    variant="transparent"
                    className={
                      reOrderButtonDisabled
                        ? 'btn-secondary opacity-25'
                        : 'btn-primary-orange'
                    }
                    disabled={reOrderButtonDisabled}
                    onClick={handleReorderSubmit}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </Modal.Body>
      </ModalStockAdjustment>
    </>
  )
}

export default DetailJobStatus
